'use client';
import OptionFilterList from './OptionFilterList';
import SidebarSection from './SidebarSection';

export const POST_DATE_OPTIONS = [
  { id: 1, name_mn: 'Өнөөдөр', name_en: 'Today' },
  { id: 2, name_mn: '3 хоног', name_en: '3 days ago' },
  { id: 3, name_mn: '7 хоног', name_en: '7 days ago' },
  { id: 4, name_mn: '30 хоног', name_en: '30 days ago' },
];

const PostDateComponent = () => {
  return (
    <SidebarSection title="Нийтлэгдсэн хугацаа">
      <OptionFilterList options={POST_DATE_OPTIONS} paramName="dayAgo" />
    </SidebarSection>
  );
};

export default PostDateComponent; 